/**
 * JsonSelectWidget
 *
 * Usage:
 *
 *    From json in the page:
 *
 *    <div
 *      class="some class names"
 *      data-component="json-select-widget"
 *      data-target-selector="#letter"
 *      data-target-event="change"
 *      data-option-label-key="name"
 *      data-option-value-key="id"
 *      data-collection-filter-key="letter_id"
 *      data-collection="[{'name': 'foo', 'id': 1, 'letter_id': 1'}]"
 *      />
 *
 *    From a json api endpoint:
 *
 *    <div
 *      class="some class names"
 *      data-component="json-select-widget"
 *      data-target-selector="#letter"
 *      data-target-event="change"
 *      data-option-label-key="name"
 *      data-option-value-key="id"
 *      data-collection-url-query-key="letter_id"
 *      data-collection-url="http://some/api/endpoint"
 *      />
 */

import React from 'react';
import {render} from 'react-dom';

import ErrorBoundary from '~src/core/services/exceptions/ErrorBoundary'

export const ELEMENT_SELECTOR = '[data-component="json-select-widget"]';


document.querySelectorAll(ELEMENT_SELECTOR)
  .forEach(function (element) {

    import(
      // this causes webpack to create a new output file of this name
      /* webpackChunkName: "component__json-select-widget" */
      './JsonSelectComponent')
      .then(({default: JsonSelectComponent}) => {
        const {value, ...props} = element.dataset
        const collection = JSON.parse(element.dataset.collection || '[]')
        const instance = (
          <ErrorBoundary>
            <JsonSelectComponent
              {...props}
              value={JSON.parse(value.replace(/'/gi, `"`))}
              collection={collection}
            />
          </ErrorBoundary>
        )
        render(instance, element.parentElement);

      });
  });
